<nimbus-filter-summary-button
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  [summary]="summary"
  [filterName]="filter.name"
  [disabled]="disabled"
  [isValueEmpty]="isValueEmpty"
  [hasError]="hasError"
  (summaryClick)="onSummaryClick()"
  (removeFilter)="onRemoveFilter()"
></nimbus-filter-summary-button>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayPanelClass="nimbus-filter-number-range-connected-overlay"
  [cdkConnectedOverlayHasBackdrop]="false"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayPositions]="cdkConnectedPositions"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayOpen]="isOpen$ | async"
  (attach)="onAttach()"
  (detach)="onDetach()"
  (overlayOutsideClick)="onOutsideClick($event)"
>
  <div class="nimbus-tooltip-complex flex-container tooltip-content">
    <div [formGroup]="form" class="range-controls">
      <mat-form-field>
        <nimbus-filter-number-range-input
          #minControl
          formControlName="min"
          [minValue]="filter.min"
          [maxValue]="filter.max"
          [defaultValue]="filter.min"
          [step]="filter.step ?? 1"
          [unit]="filter.unit"
        ></nimbus-filter-number-range-input>
      </mat-form-field>
      <span class="range-separator">-</span>
      <mat-form-field>
        <nimbus-filter-number-range-input
          formControlName="max"
          [minValue]="filter.min"
          [maxValue]="filter.max"
          [defaultValue]="filter.max"
          [step]="filter.step ?? 1"
          [unit]="filter.unit"
        ></nimbus-filter-number-range-input>
      </mat-form-field>
    </div>
  </div>
</ng-template>
